import { graphql } from 'gql/generated'

export const MARK_VEHICLE_OUT_OF_SERVICE = graphql(`
  mutation MarkVehicleOutOfService($input: MarkVehicleOutOfServiceInput!) {
    markVehicleOutOfService(input: $input)
  }
`)
